import { loadTranslations, storeTranslations, getCurrentStoredTranslationsVersion, storeTranslationsSelectedLocale, getSelectedLocale } from "../api/AsyncStorage";
import { getTranslationsVersion, getTranslations } from "../api/translations"
import _ from "lodash"

export const translations = {
    locales: {},
    version: null,
    selectedLocale: "en",
    supportedLanguages: [
        { key: "en", name: "EN", fullName: 'english' },
        { key: "ja", name: "日本語", fullName: 'japanese' },
    ],
    fallbackLocale: "en"
}

export const load = async () => {
    try {
        let currentVersion = await getCurrentStoredTranslationsVersion();
        let dbVersion = await getTranslationsVersion()
        console.log("load translation", { currentVersion, dbVersion, translations: translations })
        if (!currentVersion || dbVersion > Number(currentVersion)) {
            //load from database
            const { version, locales } = await getTranslations();
            await storeTranslations({ version: dbVersion.toString(), locales })
            translations.locales = locales;
            translations.version = version;
            return true;
        } else {
            //load from local storage
            const locales = await loadTranslations();
            const selectedLocale = await getSelectedLocale();
            translations.locales = locales;
            translations.version = dbVersion;
            translations.selectedLocale = selectedLocale;
            return true
        }
    } catch (e) {
        console.error("error loading translations", e)
        return false;
    }

}

export const setLocale = async (locale) => {
    translations.selectedLocale = locale
    await storeTranslationsSelectedLocale(locale)
    console.log("selected locale", translations.selectedLocale)
}

/** Firebase stores keys with "." replaced by "_"; support both for lookup */
const encodedKey = (k) => {
    if (k == null) return "";
    return String(k).replace(/\./g, "_");
};

export const getString = (key, defaultString = "") => {
    const enc = encodedKey(key);
    let value = _.get(
      translations.locales,
      `[${translations.selectedLocale}][${enc}]`,
      _.get(translations.locales, `[${translations.selectedLocale}][${key}]`,
      _.get(translations.locales, `[${translations.fallbackLocale}][${enc}]`,
      _.get(translations.locales, `[${translations.fallbackLocale}][${key}]`, defaultString ? defaultString : key)))
    );

    if(!value || value === key || !value.replace){
        return value;
    }
    
    // Replace literal "\n" with actual newline characters
    return value.replace(/\\n/g, "\n");
  }

export const getLocalizedString = (key, localizedDefaults = {}) => {
    const enc = encodedKey(key);
    const value = _.get(
        translations.locales,
        `[${translations.selectedLocale}][${enc}]`,
        _.get(translations.locales, `[${translations.selectedLocale}][${key}]`)
    );

    if (value && value !== key && value.replace) {
        return value.replace(/\\n/g, "\n");
    }

    const fallbackValue =
        localizedDefaults[translations.selectedLocale] ||
        localizedDefaults[translations.fallbackLocale] ||
        localizedDefaults.en ||
        key;

    return fallbackValue && fallbackValue.replace ? fallbackValue.replace(/\\n/g, "\n") : fallbackValue;
}
  

export const isJP = () => {
    return translations.selectedLocale === "ja";
}
